import { Plus } from "lucide-react";
import React, { useState } from "react";
import { Modal } from "../../Shared/Modal";
import AddProductForm from "../../components/AddProductForm";
import AgentProductsList from "./AgentProductsList";

const AgentProductPage = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  return (
    <div className="agent-product-list-page">
      <div className="flex justify-between items-center">
        <button
          onClick={() => setIsAddModalOpen(true)}
          className="flex items-center justify-center gap-2 w-[60%] h-[80px] text-black bg-[#e6e6e6] hover:bg-[#dcdcdc] rounded-lg font-medium transition border border-[#707070]"
        >
          <Plus className="w-7 h-7" />
          <span>Add Product</span>
        </button>
      </div>

      <div className="pt-5">
        <h3 className="font-semibold text-2xl">Product List</h3>
        <AgentProductsList />
      </div>

      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Add Product"
        mw="max-w-2xl"
      >
        <AddProductForm onClose={() => setIsAddModalOpen(false)} />
      </Modal>
    </div>
  );
};

export default AgentProductPage;
